export default {
    PUBLIC_KEY: `asvv3zLsotUMT_SGS`, //public_key
    TEMPLATE_ID: `template_tfegjoj`,         //templateID
    SERVICE_ID: `service_vrble69`
}